import GeneralForm from './src/main';


export default GeneralForm;



// WEBPACK FOOTER //
// ./src/common/components/extend/general-form/index.js